import styled from 'styled-components';

import { BaseButton } from '@/ui/Button/type/default/styles/button';
import { StyledIcon } from '@/ui/Button/type/default/styles/icon';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/ui/DropdownMenu';

enum SelectOptions {
  AddLearners = 'addLearners',
  AddTeams = 'addTeams',
  ImportLearners = 'importLearners',
}

const OptionStyled = styled.div`
  padding: 10px 0;
  display: flex;
  flex-direction: column;
`;

const OptionTitleStyled = styled.div`
  ${(p) => p.theme.typography.body3};
  color: ${(p) => p.theme.tones.neutral[10]};
`;

const OptionSubtitleStyled = styled.p`
  ${(p) => p.theme.typography.caption};
  color: ${(p) => p.theme.colors.neutral.outline2};
`;

type JourneyInsightsTabsParticipantsAddingButtonProps = {
  openAddParticipantsModal: VoidFunction;
  openAddTeamsModal: VoidFunction;
  onImportLearnersClick: VoidFunction;
};

export const JourneyInsightsTabsParticipantsAddingButton = ({
  openAddParticipantsModal,
  openAddTeamsModal,
  onImportLearnersClick,
}: JourneyInsightsTabsParticipantsAddingButtonProps): React.ReactElement => {
  const handleChange = (value: string | string[]) => {
    if (value === SelectOptions.AddLearners) {
      openAddParticipantsModal();
    } else if (value === SelectOptions.AddTeams) {
      openAddTeamsModal();
    } else if (value === SelectOptions.ImportLearners) {
      onImportLearnersClick();
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <BaseButton type="button" variant="primary">
          Add learners
          <StyledIcon icon="chevron-down" $iconPosition="end" />
        </BaseButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent variant="subtle" side="bottom" align="end">
        <DropdownMenuItem variant="subtle" onSelect={() => handleChange(SelectOptions.AddLearners)}>
          <OptionStyled>
            <OptionTitleStyled>Add learners</OptionTitleStyled>
            <OptionSubtitleStyled>Select and add individual learners</OptionSubtitleStyled>
          </OptionStyled>
        </DropdownMenuItem>
        <DropdownMenuItem variant="subtle" onSelect={() => handleChange(SelectOptions.AddTeams)}>
          <OptionStyled>
            <OptionTitleStyled>Add teams</OptionTitleStyled>
            <OptionSubtitleStyled>Select teams to add multiple learners</OptionSubtitleStyled>
          </OptionStyled>
        </DropdownMenuItem>
        <DropdownMenuItem variant="subtle" onSelect={() => handleChange(SelectOptions.ImportLearners)}>
          <OptionStyled>
            <OptionTitleStyled>Upload file</OptionTitleStyled>
            <OptionSubtitleStyled>Add many learners at once</OptionSubtitleStyled>
          </OptionStyled>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
